const getters = {
  getMenuSections (state) {
    return state.sections
  },
}

const mutations = {
  setMenuSections (state, value) {
    state.sections = value
  },
}

export default {
  state: { sections: [] },
  getters,
  mutations,
}
